import { Module } from "vuex";
import { state } from "./state";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { IContentState } from "@/store/modules/content/types";
import { RootState } from "@/store/types";

const namespaced: boolean = true;

export const contentModule: Module<IContentState, RootState> = {
  namespaced,
  state,
  actions,
  mutations,
};
